import { ShopperAgentChannelKind } from "@redotech/crdb-enums/shopper-ai/shopper-agent-channel-kind";
import type {
  ShopperAgentMessageChannel,
  ShopperAgentMessageChannelKind,
} from "@redotech/redo-flows-common/shopper-agent-message-channel";
import { t } from "@redotech/redo-i18n";

type EditableChannel = Partial<ShopperAgentMessageChannel>;

export const DEFAULT_SHOPPER_AGENT_MESSAGE_CHANNEL: ShopperAgentMessageChannel =
  { kind: ShopperAgentChannelKind.Sms };

function shopperAgentMessageSmsChannel(options: {
  subscribers: boolean;
  extendedOutreach: boolean;
}): ShopperAgentMessageChannel {
  if (options.extendedOutreach && !options.subscribers) {
    return {
      kind: ShopperAgentChannelKind.Sms,
      subscribers: false,
      extendedOutreach: true,
    };
  }
  if (options.extendedOutreach) {
    return { kind: ShopperAgentChannelKind.Sms, extendedOutreach: true };
  }
  return { kind: ShopperAgentChannelKind.Sms };
}

export function shopperAgentMessageChannelForKind(
  kind: ShopperAgentMessageChannelKind,
  previous: EditableChannel | null | undefined,
): ShopperAgentMessageChannel {
  if (kind === ShopperAgentChannelKind.Email) {
    return { kind: ShopperAgentChannelKind.Email };
  }
  if (previous?.kind === ShopperAgentChannelKind.Sms) {
    return shopperAgentMessageSmsChannel({
      subscribers: previous.subscribers !== false,
      extendedOutreach: previous.extendedOutreach === true,
    });
  }
  return { kind: ShopperAgentChannelKind.Sms };
}

export function shopperAgentMessageChannelWithExtendedOutreach(
  channel: EditableChannel | null | undefined,
  extendedOutreach: boolean,
): ShopperAgentMessageChannel {
  const subscribers =
    channel?.kind === ShopperAgentChannelKind.Sms
      ? channel.subscribers !== false
      : true;
  return shopperAgentMessageSmsChannel({
    subscribers: extendedOutreach ? subscribers : true,
    extendedOutreach,
  });
}

export function shopperAgentMessageChannelWithSubscribers(
  channel: EditableChannel | null | undefined,
  subscribers: boolean,
): ShopperAgentMessageChannel {
  const extendedOutreach =
    channel?.kind === ShopperAgentChannelKind.Sms &&
    channel.extendedOutreach === true;
  return shopperAgentMessageSmsChannel({
    subscribers,
    extendedOutreach: subscribers ? extendedOutreach : true,
  });
}

export function shopperAgentMessageChannelLabel(
  channel: EditableChannel | null | undefined,
): string {
  if (channel?.kind === ShopperAgentChannelKind.Email) {
    return t("Email");
  }
  if (
    channel?.kind === ShopperAgentChannelKind.Sms &&
    channel.extendedOutreach
  ) {
    return channel.subscribers === false
      ? "Recover"
      : t("Text · {{productName}}", { productName: "Recover" });
  }
  if (channel?.kind === ShopperAgentChannelKind.Sms) {
    return t("Text");
  }
  return t("Start a commerce agent conversation");
}
